import { z } from 'zod';

/** Гость просит стол с витрины; заведение назначает стол и время. */
export const PublicReservationRequest = z.object({
  locationId: z.string(),
  guestName: z.string().min(1).max(60),
  phone: z.string().min(5).max(20),
  guests: z.number().int().min(1).max(20),
  wishAt: z.string().datetime(),
});
export type PublicReservationRequest = z.infer<typeof PublicReservationRequest>;

export const ReservationRequestRow = z.object({
  id: z.string(),
  guestName: z.string(),
  phone: z.string(),
  guests: z.number().int(),
  wishAt: z.string().datetime(),
  createdAt: z.string().datetime(),
});
export const ReservationRequestsList = z.object({
  rows: z.array(ReservationRequestRow),
});
export type ReservationRequestsList = z.infer<typeof ReservationRequestsList>;

export const ApproveRequest = z.object({
  tableId: z.string(),
  startAt: z.string().datetime(),
  durationMin: z.number().int().min(30).max(360),
});
export type ApproveRequest = z.infer<typeof ApproveRequest>;
